import { ShipmentStatusEnum } from "../../../models/Shipments/ShipmentStatus";

export const MANUAL_SHIPMENT_TYPE_ID = 1;

export const canAddShipmentInventoryLines = (args: {
  status?: number | null;
  hasEditShipments: boolean;
  hasEditTerminalLines: boolean;
}): boolean => {
  try {
    const { status, hasEditShipments, hasEditTerminalLines } = args;
    if (
      status === ShipmentStatusEnum.NEW ||
      status === ShipmentStatusEnum.READY_TO_SHIP
    ) {
      return hasEditShipments;
    }
    if (
      status === ShipmentStatusEnum.SHIPPED ||
      status === ShipmentStatusEnum.DELIVERED
    ) {
      return hasEditTerminalLines;
    }
    return false;
  } catch {
    return false;
  }
};

export const canRemoveShipmentInventoryLines = (args: {
  status?: number | null;
  shipmentType?: number | null;
  hasEditShipments: boolean;
  hasEditTerminalLines: boolean;
}): boolean => {
  try {
    if (args.hasEditTerminalLines) {
      return true;
    }
    return (
      args.shipmentType === MANUAL_SHIPMENT_TYPE_ID &&
      (args.status === ShipmentStatusEnum.NEW ||
        args.status === ShipmentStatusEnum.READY_TO_SHIP) &&
      args.hasEditShipments
    );
  } catch {
    return false;
  }
};
